{
  "maximum": "Μέγιστο",
  "minimum": "Ελάχιστο"
}
